<template>
  <h3>跟随做多 理解做空 顺势而为</h3>
  <h4>如果市场交易赛力斯机器人，记住核心，拉面！</h4>
  <h5>放低心理预期、</h5>
  <div class="daily-container">
  <button @click="handleAdd" class="btn btn-primary mb-4" v-if="isAdmin">新增文章试读</button>

    <table class="custom-table" style="width: 100%">
      <thead>
        <tr>
          <th style="text-align: left; min-width: 500px;">标题</th>
          <th style="text-align: center; width: 180px;">更新时间</th>
          <th style="text-align: center; width: 220px;" class="operation-cell">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in dailies" :key="row.id" @click="handleShowDetail(row)" class="table-row">
          <td style="text-align: left;">{{ row.title }}</td>
          <td style="text-align: center;">{{ row.create_time }}</td>
          <td style="text-align: center;" class="operation-cell">
            <button
              @click.stop="handleEdit(row)"
              class="btn btn-primary btn-small action-btn"
              v-if="isAdmin"
            >
              编辑
            </button>
            <button
              @click.stop="handleDelete(row.id)"
              class="btn btn-danger btn-small action-btn"
              v-if="isAdmin"
            >
              删除
            </button>
            <button
              @click.stop="handleShowDetail(row)"
              class="btn btn-primary btn-small action-btn"
            >
              详情
            </button>
          </td>
        </tr>
      </tbody>
    </table>

 <div class="pagination mt-4">
    <button 
      class="btn pagination-btn" 
      :disabled="currentPage <= 1"
      @click="handlePageChange(currentPage - 1)"
    >
      上一页
    </button>
    <span class="pagination-info">
      第 {{ currentPage }} 页，共 {{ Math.ceil(total / pageSize) }} 页
    </span>
    <button 
      class="btn pagination-btn" 
      :disabled="currentPage >= Math.ceil(total / pageSize)"
      @click="handlePageChange(currentPage + 1)"
    >
      下一页
    </button>
  </div>

    <!-- 详情抽屉 -->
    <div class="drawer" :class="{ 'drawer-open': drawerVisible }">
      <div class="drawer-overlay" @click="handleDrawerClose"></div>
      <div class="drawer-content-wrapper" style="width: 30%">
        <div class="drawer-header">
          <h3 class="drawer-title">{{ selectedDaily.title || '详情' }}</h3>
          <button class="drawer-close" @click="handleDrawerClose">×</button>
        </div>
        <div class="drawer-content">
         <div class="mb-2">
          <span class="value">  {{ selectedDaily.content }}</span>
        </div>
      <div class="mb-2">
  <span v-if="selectedDaily.is_stock == 1 && selectedDaily.contentLinks?.length > 0">
    <span v-for="(item, index) in selectedDaily.contentLinks" :key="index" class="value">
      <a :href="item.link" target="_blank">{{ item.code }}</a>
      <span v-if="index < selectedDaily.contentLinks.length - 1">、</span>
    </span>
  </span>
  <span v-else>
    暂无
  </span>
</div>


        <div class="mb-2">
          <span class="value">{{ selectedDaily.create_time }}</span>
        </div>
      </div>
      </div>
    </div>

    <!-- 新增/编辑对话框 -->
    <Transition name="dialog">
      <div v-if="dialogVisible" class="dialog-overlay" @click.self="dialogVisible = false">
        <div class="dialog">
          <div class="dialog-header">
            <h3 class="dialog-title">{{ isEdit ? '编辑日常' : '新增日常' }}</h3>
            <button class="dialog-close" @click="dialogVisible = false">&times;</button>
          </div>
          <div class="dialog-body">
            <form :model="form" class="form">
              <div class="form-group">
                <label class="form-label">标题</label>
                <input 
                  type="text" 
                  v-model="form.title" 
                  class="form-input"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <label class="form-label">内容</label>
                <textarea 
                  v-model="form.content" 
                  class="form-input form-textarea large"
                  rows="20"
                ></textarea>
              </div>
              <div class="form-group">
                <label class="form-label">相关股票</label>
                <textarea 
                  v-model="form.stocks" 
                  class="form-input form-textarea"
                  rows="10"
                ></textarea>
              </div>
              <div class="form-group">
                <label class="form-label">是否置顶</label>
                <label class="switch">
                  <input 
                    type="checkbox" 
                    v-model="form.topic"
                    :true-value="1" 
                    :false-value="0"
                  />
                  <span class="slider"></span>
                </label>
              </div>
              <div class="form-group">
                <label class="form-label">是否股票</label>
                <label class="switch">
                  <input 
                    type="checkbox" 
                    v-model="form.is_stock"
                    :true-value="1" 
                    :false-value="0"
                  />
                  <span class="slider"></span>
                </label>
              </div>
            </form>
          </div>
          <div class="dialog-footer">
            <button class="btn" @click="dialogVisible = false">取消</button>
            <button class="btn btn-primary" @click="handleSubmit">{{ isEdit ? '保存' : '提交' }}</button>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'DailyPage',
  data() {
    return {
      dailies: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      dialogVisible: false,
      form: { title: '', content: ''},
      isEdit: false,
      editId: 0,
      drawerVisible: false,
      selectedDaily: {},
      userRole: localStorage.getItem('username') || '',
      editErrors: {}
    }
  },
  computed: {
      isAdmin() {
        return this.userRole === 'admin1984';
      }
    },
  watch: {
      userRole(newValue) {
        localStorage.setItem('username', newValue);
      }
  },
  methods: {
    // 显示消息提示
    showMessage(message, type = 'success') {
      const msg = document.createElement('div');
      msg.className = `message-toast message-toast-${type}`;
      msg.textContent = message;
      msg.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        padding: 12px 20px;
        border-radius: 4px;
        color: white;
        z-index: 9999;
        animation: slideIn 0.3s ease;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      `;
      
      if (type === 'success') {
        msg.style.backgroundColor = '#67c23a';
      } else if (type === 'error') {
        msg.style.backgroundColor = '#f56c6c';
      } else if (type === 'warning') {
        msg.style.backgroundColor = '#e6a23c';
      }
      
      document.body.appendChild(msg);
      
      setTimeout(() => {
        msg.style.animation = 'slideOut 0.3s ease';
        setTimeout(() => {
          document.body.removeChild(msg);
        }, 300);
      }, 3000);
    },
    // 表单验证
    validateForm() {
      this.editErrors = {};
      let isValid = true;
      
      if (!this.form.title) {
        this.editErrors.title = '标题不能为空';
        isValid = false;
      }
      
      if (!this.form.content) {
        this.editErrors.content = '内容不能为空';
        isValid = false;
      }
      
      return isValid;
    },
    
    handlePageChange(page) {
      this.currentPage = page; // 确保页码同步
      this.fetchData();        // 触发数据请求
    },
    async fetchData() {
      try {
        const res = await axios.get('/api/dailies', {
          params: {
            page: this.currentPage,
            pageSize: this.pageSize
          }
        })
        this.dailies = res.data.list
        this.total = res.data.total
      } catch (error) {
        this.showMessage('获取数据失败', 'error')
        console.error('Fetch data error:', error)
      }
    },
    handleAdd() {
      this.form = { title: '', content: '', topic: 0, is_stock: 0 }
      this.isEdit = false
      this.editId = 0
      this.editErrors = {}
      this.dialogVisible = true
    },
    handleEdit(daily) {
      this.form = { ...daily }
      this.isEdit = true
      this.editId = daily.id
      this.editErrors = {}
      this.dialogVisible = true
    },
    async handleDelete(id) {
      try {
        await axios.delete(`/api/dailies/${id}`)
        this.showMessage('删除成功', 'success')
        await this.fetchData()
      } catch (error) {
        this.showMessage('删除失败', 'error')
        console.error('Delete error:', error)
      }
    },
    async handleSubmit() {
      if (!this.validateForm()) {
        return;
      }
      
      const payload = { ...this.form };
      delete payload.create_time; // 不更新 create_time
      if (payload.update_time === null) {
        delete payload.update_time; // 如果 update_time 为 null，则删除该字段
      }

      try {
        if (this.isEdit) {
          await axios.put(`/api/dailies/${this.editId}`, payload);
          this.showMessage('更新成功', 'success');
        } else {
          await axios.post('/api/dailies', payload);
          this.showMessage('新增成功', 'success');
        }
        this.dialogVisible = false;
        await this.fetchData();
      } catch (error) {
        this.showMessage('操作失败', 'error');
        console.error('Submit error:', error.response?.data || error);
      }
    },

  handleShowDetail(row) {
  this.selectedDaily = { ...row };

  // 判断 stocks 是否有值
  if (row.stocks && typeof row.stocks === 'string') {
    this.selectedDaily.contentLinks = row.stocks
      .split('、')
      .filter(code => !code.trim().endsWith(':'))
      .map(code => ({
        code: code,
        link: `https://www.iwencai.com/unifiedwap/result?querytype=stock&w=${code}`
      }));
  } else {
    this.selectedDaily.contentLinks = [];
  }

  this.drawerVisible = true;
},

    handleDrawerClose() {
      this.drawerVisible = false
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>

<style scoped>
.daily-page {
  margin: 20px;
}

/* 卡片样式 */
.card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  margin-top: 20px;
}

.card-content {
  padding: 24px;
}

/* 搜索表单样式 */
.search-form {
  margin-bottom: 24px;
}

.search-row {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  align-items: end;
}

.search-group {
  flex: 1;
  min-width: 200px;
  display: flex;
  flex-direction: column;
}

.search-label {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  min-width: 80px;
}

.search-input {
  padding: 10px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  transition: all 0.3s;
  box-sizing: border-box;
}

.search-input:focus {
  outline: none;
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.search-actions {
  flex-direction: row;
  gap: 12px;
  min-width: auto;
}

/* 表格样式 */
.table-container {
  margin-top: 20px;
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
}

.data-table th,
.data-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ebeef5;
}

.data-table th {
  background-color: #f5f7fa;
  font-weight: 500;
  color: #303133;
  font-size: 14px;
  white-space: nowrap;
}

.data-table td {
  color: #606266;
  font-size: 14px;
}

.data-table tr:hover {
  background-color: #fafafa;
}

/* 操作按钮单元格样式 */
.action-buttons {
  display: flex;
  gap: 8px;
}

/* 通用按钮样式 */
.btn {
  padding: 10px 20px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: white;
  color: #606266;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
  outline: none;
}

.btn:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}

.btn-primary {
  background-color: #409eff;
  border-color: #409eff;
  color: white;
}

.btn-primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
  color: white;
}

.btn-danger {
  background-color: #f56c6c;
  border-color: #f56c6c;
  color: white;
}

.btn-danger:hover {
  background-color: #f78989;
  border-color: #f78989;
  color: white;
}

.btn-small {
  padding: 6px 12px;
  font-size: 12px;
}

/* 对话框样式 */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.dialog {
  background-color: white;
  border-radius: 8px;
  width: 600px;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
}

.dialog-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  margin: 0;
}

.dialog-close {
  background: none;
  border: none;
  font-size: 20px;
  color: #909399;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.3s;
}

.dialog-close:hover {
  background-color: #f5f7fa;
  color: #606266;
}

.dialog-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #ebeef5;
  background-color: #f5f7fa;
}

/* 表单样式 */
.form {
  width: 100%;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  min-width: 100px;
}

.form-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  transition: all 0.3s;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.form-input.error {
  border-color: #f56c6c;
}

.form-input.error:focus {
  border-color: #f56c6c;
  box-shadow: 0 0 0 2px rgba(245, 108, 108, 0.2);
}

.form-input-disabled {
  background-color: #f5f7fa;
  color: #c0c4cc;
  cursor: not-allowed;
}

/* 表单行布局 */
.form-row {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.form-row .form-group {
  flex: 1;
  margin-bottom: 0;
}

/* 错误提示样式 */
.error-message {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 4px;
}

/* 对话框动画 */
.dialog-enter-active,
.dialog-leave-active {
  transition: opacity 0.3s ease;
}

.dialog-enter-from,
.dialog-leave-to {
  opacity: 0;
}

.dialog-enter-active .dialog,
.dialog-leave-active .dialog {
  transition: transform 0.3s ease;
}

.dialog-enter-from .dialog {
  transform: translate3d(0, -20px, 0);
}

.dialog-leave-to .dialog {
  transform: translate3d(0, -20px, 0);
}

/* 动画效果 */
@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
}

/* 消息提示样式 */
.message-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 20px;
  border-radius: 4px;
  color: white;
  z-index: 9999;
  animation: slideIn 0.3s ease;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.message-toast-success {
  background-color: #67c23a;
}

.message-toast-error {
  background-color: #f56c6c;
}

.message-toast-warning {
  background-color: #e6a23c;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .daily-page {
    margin: 10px;
  }
  
  .card-content {
    padding: 16px;
  }
  
  .search-row {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
  
  .search-actions {
    flex-direction: column;
  }
  
  .btn {
    width: 100%;
  }
  
  .form-row {
    flex-direction: column;
    gap: 20px;
  }
  
  .dialog {
    width: 95vw;
    margin: 20px;
  }
  
  .dialog-header,
  .dialog-body,
  .dialog-footer {
    padding: 12px 16px;
  }
  
  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }
}
</style>
